module.exports = __webpack_public_path__ + "img/logo-sm-light.98881b8c.svg";